import {BaseModel} from "./base-model";

export class BaseApiModel extends BaseModel {
  sortIndex: Number;
  constructor() {
    super();

    this.sortIndex = -1;
  }
}
